import cleanedFilename from '~/util/cleanedFilename';

export default {
  DROPDOWN: `${cleanedFilename(__filename)}-dropdown`,
};
